/// <reference types="intro.js" />
import introJs from "intro.js";

type IntroPosition = 'left' | 'right' | 'top' | 'bottom' | 'bottom-left-aligned' | 'bottom-middle-aligned' | 'bottom-right-aligned' | 'auto';

export abstract class Intro {

    private isInitialized: boolean = false;
    private intro: introJs.IntroJs;
    private steps: IntroStep[] = [];

    protected abstract Name: string;

    protected abstract AddSteps(): void;

    protected OnChange(to: string): void { /* TODO document why this method 'OnChange' is empty */  }

    private OnChangeProxy(element: HTMLElement): void {
        const toStep: IntroStep = this.steps.find(value => value.Element == element);
        this.OnChange(toStep?.Name);      
    }

    private OnCompleteProxy(): void {
        window.SettingsManager.setAttribute(this.Name, true);
        this.OnChange(null);
    }

    private OnExitProxy(): void {
        window.SettingsManager.setAttribute(this.Name, true);
        this.OnChange(null);
    }

    public HasBeenRun(): boolean {
        return Boolean(window.SettingsManager.getAttribute(this.Name));
    }

    public Start(): void {
        if (!this.IsInitialized()) {
            this.Build();
        }

        this.intro.start();
    }

    public AutoStart(): void {
        if (!this.HasBeenRun()) {
            this.Start();
        }
    }

    protected AddStep(name: string, element: HTMLElement, position: IntroPosition, func: Function): void {
        this.steps.push(<IntroStep>{
            Name: name,
            TextGenerator: func,
            Element: element,
            Position: position
        });
    }

    private IsInitialized(): boolean {
        return this.isInitialized;
    }

    private Build(): void {
        this.AddSteps();

        this.intro = this.CreateIntroJsInstanceWithDefaultConfiguration();

        for (let i = 0; i < this.steps.length; ++i) {
            let step: IntroStep = this.steps[i];

            this.intro.addStep(<introJs.Step>{
                element: step.Element,
                intro: step.TextGenerator(i + 1, this.steps.length),
                position: step.Position
            });
        }

        this.isInitialized = true;
    }

    private CreateIntroJsInstanceWithDefaultConfiguration() {
        return introJs()
            .setOption('exitOnOverlayClick', 'false')
            .setOption('prevLabel', 'Előző')
            .setOption('nextLabel', 'Következő')
            .setOption('skipLabel', 'x')
            .setOption('doneLabel', 'x')
            .setOption('showBullets', false)
            .setOption('disableInteraction', true)
            .onchange(element => this.OnChangeProxy(element))
            .oncomplete(() => this.OnCompleteProxy())
            .onexit(() => this.OnExitProxy());
    }
}

class IntroStep {
    public Name: string;
    public Element: HTMLElement;
    public Position: IntroPosition;
    public TextGenerator: Function;
}
